import { render, staticRenderFns } from "./BimUpload.vue?vue&type=template&id=135cdeca"
import script from "./BimUpload.vue?vue&type=script&lang=js"
export * from "./BimUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports